"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.computeHandScore = exports.getCardScoreGroup = exports.getCardScore = exports.CARD_ACTION_SCORE = exports.CARD_WILD_SCORE = void 0;
exports.CARD_WILD_SCORE = 50;
exports.CARD_ACTION_SCORE = 20;
const WILD_TYPES = ["DRAW", "COLOR"];
const ACTION_TYPES = ["REVERSE", "BLOCK", "PLUS"];
const getCardScore = (cardType) => {
    const item = cardType.substring(1).toUpperCase();
    if (WILD_TYPES.includes(item)) {
        return exports.CARD_WILD_SCORE;
    }
    if (ACTION_TYPES.includes(item)) {
        return exports.CARD_ACTION_SCORE;
    }
    return parseInt(item) || 0;
};
exports.getCardScore = getCardScore;
const getCardScoreGroup = (cardType) => {
    const item = cardType.substring(1).toUpperCase();
    if (WILD_TYPES.includes(item)) {
        return "wilds";
    }
    if (ACTION_TYPES.includes(item)) {
        return "actions";
    }
    return "numbers";
};
exports.getCardScoreGroup = getCardScoreGroup;
const computeHandScore = (hand) => {
    return hand.reduce((sum, card) => sum + (0, exports.getCardScore)(card.type), 0);
};
exports.computeHandScore = computeHandScore;
